module.exports = __webpack_public_path__ + "static/media/CircuitV2d.32c5366a.jpeg";